module.exports = {
  GLOBAL: 'Treasure',
  VERSION: '3.0.0',
  HOST: 'in.treasuredata.com',
  DATABASE: '',
  PATHNAME: '/js/v3/event/'
}
